import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function BillingCancel() {
  return (
    <div className="grid place-items-center py-20">
      <Card className="p-10 rounded-2xl text-center max-w-md">
        <h1 className="font-display text-2xl font-bold mb-2">Checkout cancelled</h1>
        <p className="text-slate-500 mb-6">No charge was made. You can try again anytime.</p>
        <Link to="/settings"><Button className="rounded-full bg-primary hover:bg-primary/90">Back to Settings</Button></Link>
      </Card>
    </div>
  );
}
